import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TooltipProvider } from "@/components/ui/tooltip";
import { StatusIndicators } from "../../logger/components/StatusIndicators";
import { socketService, type ConnectionStatus } from "../../../services/socket";
import { logBuffer } from "../../../services/logBuffer";

type TranscriptionStatus = "idle" | "started" | "error" | "stopped";

export const ConnectionStatusWidget: React.FC = () => {
  const { t } = useTranslation();
  const [connectionStatus, setConnectionStatus] = useState<ConnectionStatus>(
    socketService.connectionStatus,
  );
  const [transcriptionStatus, setTranscriptionStatus] = useState<TranscriptionStatus>("idle");
  const [pendingLogsCount, setPendingLogsCount] = useState(logBuffer.pendingCount);

  useEffect(() => {
    const unsubConnection = socketService.onConnectionChange(() => {
      setConnectionStatus(socketService.connectionStatus);
    });
    const unsubPending = logBuffer.onChange((pending) => {
      setPendingLogsCount(pending.length);
    });

    const handleTranscriptionStatus = (data: { status?: string }) => {
      const next = data?.status;
      if (next === "idle" || next === "started" || next === "error" || next === "stopped") {
        setTranscriptionStatus(next);
      }
    };
    socketService.on("relay:status_update", handleTranscriptionStatus);

    return () => {
      unsubConnection();
      unsubPending();
      socketService.off("relay:status_update", handleTranscriptionStatus);
    };
  }, []);

  return (
    <TooltipProvider delay={150}>
      <StatusIndicators
        connectionStatus={connectionStatus}
        transcriptionStatus={transcriptionStatus}
        pendingLogsCount={pendingLogsCount}
        t={t}
      />
    </TooltipProvider>
  );
};
